module.exports = __webpack_public_path__ + "static/media/everest-logo.bb8706c5.svg";